import { actions } from "../../js/state-machine";

export const alignments = {
    end: "END",
    middle: "MIDDLE",
    start: "START",
};

export const defaultState = {
    top: "initial",
    left: "initial",
    right: "initial",
    bottom: "initial",
};

// Vertical actions
const verticalActions = [actions.types.bottom, actions.types.top];

// Horizontal actions
const horizontalActions = [actions.types.left, actions.types.right];

/**
 * Returns the position (x,y) that best fits action.pop
 * considering the position of action.trigger.
 * @param {Object} state
 * @param {Object} action
 * - type (actions.types)
 * - pop (rect)
 * - trigger (rect)
 * - alignment? (alignments)
 * @returns {x,y}
 */
export default function PopReducer(state = {}, action) {
    const { trigger, pop } = action;
    if (!trigger || !pop) return state;

    const triggerRect = trigger.getBoundingClientRect();
    const popRect = pop.getBoundingClientRect();

    const newState = Object.assign(defaultState, state);

    if (verticalActions.includes(action.type)) {
        // Type/Position
        switch (action.type) {
            case actions.types.bottom:
                newState.bottom = "initial";
                newState.top = Math.round(triggerRect.height) + "px";
                break;
            case actions.types.top:
                newState.bottom = Math.round(triggerRect.height) + "px";
                newState.top = "initial";
                break;
        }
        // Alignment
        switch (action.alignment) {
            case alignments.start:
                newState.left = "0px";
                newState.right = "initial";
                break;
            case alignments.end:
                newState.left = "initial";
                newState.right = "0px";
                break;
            case alignments.middle:
                newState.left = Math.round(Math.abs(popRect.width - triggerRect.width) / 2) + "px";
                // If pop is bigger need to pull left, otherwise, push left
                if (popRect.width > triggerRect.width) newState.left = "-" + newState.left;
                newState.right = "initial";
                break;
        }
    }

    if (horizontalActions.includes(action.type)) {
        // Type/Position
        switch (action.type) {
            case actions.types.left:
                newState.left = "initial";
                newState.right = Math.round(triggerRect.width) + "px";
                break;
            case actions.types.right:
                newState.left = Math.round(triggerRect.width) + "px";
                newState.right = "initial";
                break;
        }
        // Alignment
        switch (action.alignment) {
            case alignments.start:
                newState.bottom = "initial";
                newState.top = "0px";
                break;
            case alignments.end:
                newState.bottom = "0px";
                newState.top = "initial";
                break;
            case alignments.middle:
                newState.bottom = "initial";
                newState.top = Math.round(Math.abs(popRect.height - triggerRect.height) / 2) + "px";
                // If pop is bigger need to pull top, otherwise, push top
                if (popRect.height > triggerRect.height) newState.top = "-" + newState.top;
                break;
        }
    }

    return newState;
}
